import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=66210ce2&scoped=true"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=66210ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66210ce2",
  null
  
)

export default component.exports